import {
  AlertDialog as ChakraAlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';
import React, { useRef } from 'react';

type AlertDialogProps = {
  isOpen: boolean;
  message: string;
  title: string;
  onClose: () => void;
  onOk: () => void;
  onCancel?: () => void;
};

export const AlertDialog: React.FC<AlertDialogProps> = ({ isOpen, onClose, onOk, onCancel, title, message }) => {
  const cancelRef = useRef(null);

  return (
    <ChakraAlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => {
        onClose();
      }}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>{message}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onOk}>
              OK
            </Button>
            {onCancel !== undefined && (
              <Button style={{ marginLeft: 15 }} ref={cancelRef} onClick={onOk}>
                Cancel
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </ChakraAlertDialog>
  );
};
